export { default } from "./ChartSkeletonView";
